var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('product.description')))]),_c('p',{staticClass:"description-text"},[_vm._v(" "+_vm._s(_vm.description || _vm.$t('product.noDescription'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }